import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ProfilService } from 'src/app/services/profil/profil.service';
import { UserService } from 'src/app/services/user/user.service';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { KeyColumn } from 'src/app/utils/interfaces/new/key-column.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { Utilisateur } from 'src/app/utils/interfaces/new/utilisateur.interface';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {

  public userColumnTable: KeyColumn[] = [];
  public profilList: Paginated<any>;
  public userList = [];
  public search = '';
  public searchUser = 'user';
  public filtre: Filtres = {
    perpage: 8,
    currentPage: 1
  };

  constructor(
    private profilService: ProfilService,
    private userService: UserService,
    private router: Router,
    private modalService: ModalService,
    private viewContainerRef: ViewContainerRef
  ) { }

  async ngOnInit(): Promise<void> {
    await this.getProfils();
    this.userColumnTable = [
      { title: 'Nom d\'utilisateur', data: 'username' },
      { title: 'Nom du cabinet', data: 'cabinetNom' },
      { title: 'Effacer', data: null },
      { title: 'Modifier', data: null }
    ];
  }

  public async delete(profil: Profil): Promise<void> {
    const modal = this.modalService.openModalConfirmation(this.viewContainerRef, 'Confirmation', 'Voulez-vous vraiment supprimer cet utilisateur ?');
    modal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        const loadingModal = await this.modalService.openLoading(this.viewContainerRef);
        try {
          const profilComplet = await this.profilService.findOne(profil.id);
          profil = profilComplet;

          if (profil.disabled) {
            await this.profilService.enableProfil(profil);
          } else {
            await this.profilService.disableProfil(profil);
          }
          this.getProfils();
          this.modalService.close(loadingModal);
        } catch (e) {
          this.modalService.close(loadingModal);
          console.error(e);
        }
      }
    });
  }

  public async onSort(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.sortOrder = event.sortOrder;
    this.filtre.sortBy = event.sortBy;
    this.getProfils();
  }

  public async onSearch(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.find = event;
    this.getProfils();
  }

  public async onChangePage(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.getProfils();
  }

  public async getProfils(): Promise<void> {
    this.profilList = await this.profilService.find(this.filtre);
    for (const profil of this.profilList.objects) {
      profil.username = profil.utilisateur?.pseudo;
      profil.cabinetNom = profil.cabinet?.nom;
    }
  }

  public edit(profil: Profil): void {
    this.router.navigateByUrl(`/administration/user-creation/${profil.idCabinet}/${profil.id}`);
  }
}
